<template>
	<div class="outer">
		<Title :title="'电压电流温度监测'" style="width: 500px"></Title> <br>
		<!-- {{ style.height }} -->
		<Chart
			v-if="currentIndex == 0"
			:cdata="cdata1"
			:height="style.height"
			:width="style.width" />
		<Chart
			v-if="currentIndex == 1"
			:cdata="cdata2"
			:height="style.height"
			:width="style.width" />
		<div class="tabOuter flex justify-center">
			<div class="tabItem" v-for="(i,idx) in tabItem" :key="idx" :class="{'selected':currentIndex==idx}"
				@click="clickTab(idx)">{{i}}</div>
		</div>
	</div>
</template>

<script>
	// import BigTitle from '../bigTitle';
	import Chart from '../charts/chart'
	import Title from '@/components/title'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	import {
		formatTime
	} from '@/utils/index'

	export default {
		data() {
			return {
				tabItem: [
					"电压/电流",
					"温度"
				],
				currentIndex: 0,
				style: {
					width: '100%',
					height: '1500'
				},
				cdata1: {
					category: [
						"1月",
						"2月",
						"3月",
						"4月",
						"5月",
						"6月",
						"7月",
						"8月",
						"9月",
						"10月",
						"11月",
						"12月",
					],
					rateData: [],
					id: "carAddChart",
					legendData: [{
						name: "充电机电流",
						icon: 'roundRect',
					}, {
						name: "充电机电压",
						icon: 'roundRect',
					}, {
						name: "电池单体最高电压",
						icon: 'roundRect',
					}, {
						name: "电池单体最低电压",
						icon: 'roundRect',
					}, {
						name: "电池平均电压",
						icon: 'roundRect',
					}, {
						name: "单体电压",
						icon: 'roundRect',
					}],
					series: [
						// {
						// 	smooth: true,
						// 	symbolSize: 1,
						// 	yAxisIndex: 1,
						// 	name: "充电机电流",
						// 	type: "line",
						// 	barWidth: 10,
						// 	showSymbol: false,
						// 	data: []
						// },
						// {
						// 	smooth: true,
						// 	symbolSize: 1,
						// 	yAxisIndex: 1,
						// 	name: "充电机电压",
						// 	type: "line",
						// 	barWidth: 10,
						// 	showSymbol: false,
						// 	data: []
						// },
						{
							name: "电池单体最高电压",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "电池单体最低电压",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "电池平均电压",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "单体电压",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
					],
					yAxisname: ""
				},
				cdata2: {
					category: [],
					rateData: [],
					id: "tempChart",
					// 单体最高温度、单体最低温度和平均温度
					legendData: [{
						name: "单体最高温度",
						icon: 'roundRect',
					}, {
						name: "单体最低温度",
						icon: 'roundRect',
					}, {
						name: "平均温度",
						icon: 'roundRect',
					}, {
						name: "单体温度",
						icon: 'roundRect',
					}],
					series: [{
							name: "单体最高温度",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "单体最低温度",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "平均温度",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
						{
							name: "单体温度",
							type: "line",
							barWidth: 10,
							showSymbol: false,
							data: []
						},
					],
					yAxisname: ""
				},
				batcellvoltlist: [],
				probetemplist: []
			};
		},
		components: {
			// BigTitle,
			Chart,
			Title
		},
		mounted() {
			this.$EventBus.$on('changeTem', (data) => {
				this.changeTemp && this.changeTemp(data);
			})
		},
		methods: {
			changeTemp(data) {
				let index = data.index;
				console.log("切换单体电压", index)
				console.log("切换单体电压", this.batcellvoltlist[index])
				console.log("切换单体温度", this.probetemplist[index])

				this.cdata1.series[3].data = this.batcellvoltlist[index];
				this.cdata2.series[3].data = this.probetemplist[index];
			},
			getData(data) {
				this.chargeLineMap(data)
			},
			clickTab(index) {
				if (this.currentIndex != index) {
					this.currentIndex = index;
				}
			},
			chargeLineMap(data = {}) {
				let _this = this;
				let date = new Date();
				let ts = "";
				let year = date.getFullYear();
				let mouth = date.getMonth() + 1;
				// mouth = mouth.length>1?mouth:"0"+mouth;
				let params = {
					// "enCode":"TD-dianchixiang-dianyadianliuwendujiance",
					// "enCode": "TiDB-dianchidianyadianliuwenduliebiao",
          "enCode": "per_vehicle-电池监控-电流电压温度检测",
					"@bn": data.batteryId,
					// "@date":year+"-"+mouth+"-01 00:00:00"
				}
				dataInterface
					.dataFaceApi(params)
					.then((res) => {
						if (!res) return;
						console.log("电池电压新", res)
						this.chargeLineObj = res;

						let chgOutputCurrList = [];
						let chgOutputVoltList = [];
						let maximumCellVoltageList = [];
						let minimumCellVoltageList = [];
						let avgCellVoltageList = [];

						let maximumMonomerList = [];
						let minimumMonomerList = [];
						let avgMonomerList = [];
						let xList = [];

						res.forEach(item => {
              chgOutputCurrList.push(item.chgOutputCurr);
							chgOutputVoltList.push(item.currTotalInterVoltV1);
							maximumCellVoltageList.push(item.batMaxVolt);
							minimumCellVoltageList.push(item.batMinVolt);
							maximumMonomerList.push(item.batMaxTemp);
							minimumMonomerList.push(item.batMinTemp);
              avgCellVoltageList.push(((parseFloat(item.batMaxVolt) + parseFloat(item
								.batMinVolt)) / 2).toFixed(2));
							avgMonomerList.push((parseFloat(item.batMaxTemp) + parseFloat(item.batMinTemp)) /
								2);
              
						  // chgOutputCurrList.push(item.chgOutputCurr);
							// chgOutputVoltList.push(item.currTotalInterVoltV1);
							// maximumCellVoltageList.push(item.shsvn);  // 电池最高电压
							// minimumCellVoltageList.push(item.slvn);  // 电池最低电压
							// maximumMonomerList.push(item.shstn);  // 最高温度
							// minimumMonomerList.push(item.slstn);  // 最低温度
              // avgCellVoltageList.push(((parseFloat(item.shsvn) + parseFloat(item
							// 	.slvn)) / 2).toFixed(2));
							// avgMonomerList.push((parseFloat(item.shstn) + parseFloat(item.slstn)) /
							// 	2);

							xList.push(formatTime(item.ts, 'yyyy-MM-dd HH:mm:ss'), );
							const listArr = item.batcellvoltlist && item.batcellvoltlist.split(',') || [];
							const probetemplist = item.probetemplist && item.probetemplist.split(',') || [];
							listArr.forEach((list, idx) => {
								if (!this.batcellvoltlist[idx]) {
									this.batcellvoltlist[idx] = [];
								}
								this.batcellvoltlist[idx].push(list);
							})

							probetemplist.forEach((list, idx) => {
								if (!this.probetemplist[idx]) {
									this.probetemplist[idx] = [];
								}
								this.probetemplist[idx].push(list);
							})

						})
            console.log(xList, 'xList')
						this.cdata1.category = xList; //
						this.cdata2.category = xList; //

						// this.cdata1.series[0].data = chgOutputCurrList;
						// this.cdata1.series[1].data = chgOutputVoltList;
						this.cdata1.series[0].data = maximumCellVoltageList;
						this.cdata1.series[1].data = minimumCellVoltageList;
						this.cdata1.series[2].data = avgCellVoltageList;

						this.cdata2.series[0].data = maximumMonomerList;
						this.cdata2.series[1].data = minimumMonomerList;
						this.cdata2.series[2].data = avgMonomerList;

						this.cdata1.series[3].data = this.batcellvoltlist[0];
						this.cdata2.series[3].data = this.probetemplist[0];
					})
					.catch((err) => {
						console.log(err);
					});
			},


		}
	};
</script>

<style lang="scss" scoped>
	.outer {
		position: relative;

		.tabOuter {
			border: 1px solid #086D6A;
			width: 142px;
			padding: 5px;
			position: absolute;
			top: 15%;
			left: 45%;

			.tabItem {
				padding: 0 5px;

				&.selected {
					background: #086D6A;
				}
			}
		}

	}
</style>